import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { IntegrationKey } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useIntegrationDetailsContext } from 'pages/settings/pages/integrations/context/integrationDetailsContext'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import { SettingsRoutes } from 'pages/settings/route/type'

export const IntegrationDetailsIndexRedirect = observer(() => {
  const { integration } = useIntegrationDetailsContext()
  const { featureFlagsStore } = useEntitiesContext()
  const { salesmsg_design_v2_salesforce, zoho_integration } = featureFlagsStore

  useEffect(() => {
    if (!integration) return

    if (integration.key === IntegrationKey.webhook) {
      uiStore.changeRouteViaVue({
        path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${IntegrationsRoutes.webhooks}`,
        method: 'replace',
      })
      return
    }

    if (
      integration.isConnectedSettingsAvailable ||
      (integration.key === 'salesforce' && salesmsg_design_v2_salesforce) ||
      integration.key === 'agentforce' ||
      integration.key === 'salesmsg_mcp' ||
      (integration.key === 'zoho' && zoho_integration) ||
      integration.key === IntegrationKey['twilio-integration'] ||
      (integration.isConnected && (integration.is_ampersand || integration.key === 'front'))
    ) {
      uiStore.changeRouteViaVue({
        path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${integration.key}/${IntegrationsRoutes.settings}`,
        method: 'replace',
      })
    } else {
      uiStore.changeRouteViaVue({
        path: `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${integration.key}/${IntegrationsRoutes.description}`,
        method: 'replace',
      })
    }
  }, [integration])

  return null
})
